import { scheduledEventModel } from 'APP/model/model';
import Entities from 'STORE';

export const getScheduledEventDetails = async (eventId: string): Promise<void> => {
  const response = await scheduledEventModel.getScheduledEventDetails(eventId);

  Entities.scheduledEvents.addScheduledEventDetails(response);
};
